import React, { useEffect, useState } from "react";
import background from '../../assets/logo.png'

import {
    Container,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Button,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Paper,
    Typography,
    OutlinedInput,
} from "@mui/material";
import axios from "axios";

const center = [{
    "center": "4341",
    "area": "Gurugram ,Haryana"
},
{
    "center": "4342",
    "area": "Karnal ,Haryana"
}, {
    "center": "4343",
    "area": "Panipat ,Haryana"
}, {
    "center": "4344",
    "area": "Ambala ,Haryana"
},
{
    "center": "4345",
    "area": "Ambala ,Haryana"
}, {
    "center": "4346",
    "area": "Shahbad ,Haryana"
}, , {
    "center": "4347",
    "area": "Chandigarh ,Haryana"
}]
const UserTable = () => {
    const [userList, setUserList] = useState([])
    const [selectedValues, setSelectedValues] = useState({});
    const [valueList, setValue] = useState([])

    const handleChange = (event, index) => {
        const {
            target: { value },
        } = event;
        setSelectedValues((prev) => ({ ...prev, [index]: value }));
        setValue(value)
    };
    useEffect(() => {
        getAllUser()
    }, [])
    // useEffect(() => {
    //     console.log(userList)
    //     if (userList.length > 0)
    //         getAssignedCenter()
    // }, [userList])
    // console.log(valueList);
    // const getAssignedCenter = async () => {

    //     for (let i in userList) {
    //         if (userList[i].activeStatus === true) {
    //             let data = {
    //                 userId: userList[i].userId,
    //             }
    //             console.log({ userId: userList[i].userId, })
    //             const validateUser = await axios.post("http://localhost:8000/api/v1/user/home", data);
    //             console.log(validateUser?.data?.data?.mappedArea)
    //             if(validateUser?.data?.data?.mappedArea?.length >0)
    //             setSelectedValues((prev) => ({ ...prev, [parseInt(i)]: validateUser?.data?.data?.mappedArea }));
    //         }
    //     }
    // }

    const getAllUser = async () => {
        try {
            const loginUser = await axios.get("https://surveryindia.xyz/api/v1/admin/userList");
            setUserList(loginUser.data.data)
        } catch (error) {
            alert("unable to get the list")
        }
    }
    const userApproval = async (userId, password) => {
        try {
            let data = {
                userId: userId,
                status: password
            }
            const validateUser = await axios.post("https://surveryindia.xyz/api/v1/admin/validateUser", data);
            if (validateUser.data.status == 200) {
                getAllUser()
            } else {
                alert('unable to update the Status')
            }

        } catch (error) {
            console.log("unable to get the list")
            console.log(error)
        }
    }
    const downloadExcel = async (userId) => {
        try {
            const response = await axios({
                url: `https://surveryindia.xyz/api/v1/admin/sharePdfFunction/${userId}`, // Update with your correct API endpoint
                method: 'GET',
                responseType: 'blob', // Important for binary data
            });

            // Create a Blob from the Excel file data
            const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

            // Create a download link
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'survey_data.xlsx'; // The filename to save as
            link.click();
        } catch (error) {
            console.log("unable to get the download")
            console.log(error)
        }
    }
    return (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh", backgroundColor: "#f4f4f4", marginLeft: -30, width: '100%' }}>
            <div style={{ position: "absolute", top: 0, left: 0, width: "100%", backgroundColor: "#0000cc", height: "60px", display: "flex", alignItems: "center", justifyContent: "space-between", zIndex: 100 }}>
                <Typography variant="h6" style={{ color: "white", fontWeight: "bold" }}></Typography>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <img src={background} alt="Logo" style={{ width: "130px", marginTop: "150px", paddingRight: "50px", marginBottom: "20px" }} />
                    <Select defaultValue="English" variant="outlined" style={{ color: "blue", background: "white", borderRadius: "4px", height: "35px", marginRight: 50 }}>
                        <MenuItem value="English">English</MenuItem>
                        <MenuItem value="Hindi">Hindi</MenuItem>
                    </Select>
                </div>
            </div>
            <div style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", opacity: 0.1 }}>
                <img src={background} alt="Background Logo" style={{ width: "70%" }} />
            </div>
            <div style={{ display: "flex", flexDirection: "column", width: '95%' }}>
                <Button
                    variant="outlined"
                    sx={{ marginBottom: 2, color: "darkblue", borderColor: "darkblue", width: 200 }}
                >
                    Download
                </Button>
                <TableContainer component={Paper} sx={{ maxWidth: window.innerWidth , marginTop:70}}>
                    <Table>
                        <TableHead style={{ backgroundColor: "#0000ff", color: "white" }}>
                            <TableRow>
                                <TableCell>Name</TableCell>
                                <TableCell>Designation</TableCell>
                                <TableCell>Contact No</TableCell>
                                <TableCell>Name of Sanstha Prant</TableCell>
                                <TableCell>Complete Address</TableCell>
                                <TableCell>Name of Sanstha Pramukh</TableCell>
                                <TableCell>Contact No of Pramukh</TableCell>
                                {/* <TableCell>List of Kshetra</TableCell> */}
                                <TableCell>Approve</TableCell>
                                <TableCell>Download</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {userList?.map((row, index) => (
                                <TableRow key={index}>
                                    <TableCell>{row.name}</TableCell>
                                    <TableCell>{row.designation}</TableCell>
                                    <TableCell>{row.phoneNumber}</TableCell>
                                    <TableCell>{row.sansthaName}</TableCell>
                                    <TableCell>{row.completeAdress}</TableCell>
                                    <TableCell>{row.sansthaPramukh}</TableCell>
                                    <TableCell>{row.pramukhNumber}</TableCell>
                                    {/* <TableCell>
                                        <FormControl fullWidth style={{ display: "flex", flexWrap: "wrap" }}>
                                            <InputLabel>Select</InputLabel>
                                            <Select
                                                multiple
                                                value={selectedValues[index] || []}
                                                onChange={(event) => handleChange(event, index)}
                                                input={<OutlinedInput label="Select" />}
                                                renderValue={(selected) => selected.map(value => center.find(c => c.center === value)?.area).join(", ")}
                                                onClose={() => { assingCenter(row.userId) }}
                                            >
                                                {center.map((item) => (
                                                    <MenuItem key={item.center} value={item.center}>{item.area}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </TableCell> */}
                                    <TableCell>
                                        {row?.activeStatus ?
                                            <Button
                                                variant="outlined"
                                                sx={{ color: "blue", borderColor: "blue" }}
                                                onClick={() => { userApproval(row.userId, false) }}
                                            >
                                                Approved
                                            </Button>
                                            : <Button variant="contained" color="primary" onClick={() => { userApproval(row.userId, true) }}>Approve</Button>}
                                    </TableCell>
                                    <TableCell>
                                        <Button variant="contained" color="primary" onClick={() => { downloadExcel(row.userId) }}>Download</Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </div >
    );
};

export default UserTable;
